import Vue from 'vue'
import gql from 'graphql-tag'

import createGraphQLClient from '@utils/graphql'

let graphqlClient = null

export const state = {
    objects: {},
}

export const getters = {}

export const mutations = {
    SET_SITES(state, objects) {
        let updatedObjects = {}
        for (let key in objects) {
            if (!objects[key].deleted_at) {
                // Remove the '__typename' field that gets added by GraphQL
                delete objects[key].__typename
                // Stage the update so we can just do one Vue.set
                updatedObjects[objects[key].id] = objects[key]
            } else if (state.objects.hasOwnProperty(objects[key].id)) {
                // Immediately delete the object
                Vue.delete(state.objects, objects[key].id)
            }
        }
        state.objects = {
            ...updatedObjects,
        }

    },
    SET_SITE(state, objects) {
        state.currentSite = objects
    },
}

export const actions = {
    init({ commit, rootState }) {
        // Initialise the GraphQL client
        graphqlClient = createGraphQLClient(rootState)
    },

    async siteById({ commit }, { id } = {}) {
        try {
            const response = await graphqlClient.query({
                query: gql`
                  query siteById($sid: ID!) {
                    siteById(id: $sid) {
                      id
                      address
                      suburb
                      state
                      country
                      postcode
                      location_type
                      services
                      lat
                      lon
                      email
                      mobile
                      phone
                      contact_name
                      trading_name
                      client_id
                      created_at
                      updated_at
                      deleted_at
                    }
                  }
                `,
                variables:{ sid: id }
            })
            commit('SET_SITE', response.data.siteById)
        } catch (ex) {
            console.error(ex)
            throw ex
        }
    },
    async sitesByClientId({ commit }, { clientId } = {}) {
        try {
            await graphqlClient.query({
                query: gql`
                  query sitesByClientId($Client: ID!) {
                    sitesByClientId(client_id: $Client) {
                      id
                      address
                      suburb
                      state
                      country
                      postcode
                      location_type
                      services
                      lat
                      lon
                      email
                      mobile
                      phone
                      contact_name
                      trading_name
                      client_id
                      created_at
                      updated_at
                      deleted_at
                    }
                  }
                `,
                variables:{ Client: clientId }
            }).then((response) => {
              commit('SET_SITES', response.data.sitesByClientId)
            })
        } catch (ex) {
            console.error(ex)
            throw ex
        }
    },

    async createSite({ commit, dispatch }, {address, suburb, state, postcode, country, phone, clientId, mobile, contactName, email, tradingName} = {}) {
        try {
            // let that = this
          // console.log(address)
          // console.log(suburb)
          // console.log(state)
          // console.log(postcode)
          // console.log(country)
          // console.log(phone)
          // console.log(clientId)
          // console.log(mobile)
          // console.log(contactName)
          // console.log(email)
          // console.log(tradingName)
            await graphqlClient.mutate({
                mutation: gql`
                mutation createSite($Address: String $Suburb: String $State: String $Country: String $Postcode: Int $Client: ID $Phone: String $Mobile:String $ContactName: String $Email: String $TradingName: String)  {
                  createSite(site:{address:$Address suburb:$Suburb state:$State country:$Country postcode:$Postcode client_id:$Client phone:$Phone mobile:$Mobile contact_name:$ContactName email:$Email trading_name:$TradingName}) {
                    id
                  }
                }
                `,
                variables: {Address: address, Suburb: suburb, State: state, Postcode: postcode, Country: country, Phone: phone, Client: clientId, Mobile: mobile,ContactName: contactName,Email: email,TradingName: tradingName},
            })
        } catch (ex) {
            console.error(ex)
            throw ex
        }
    },
    async updateSite({ commit }, {id, address, suburb, state, postcode, country, phone, clientId, mobile, contactName, email, tradingName} = {}) {
    try {
        // let that = this
        const response = await graphqlClient.mutate({
            mutation: gql`
            mutation UpdateSite($cid:Int! $Address: String $Suburb: String $State: String $Country: String $Postcode: Int $Client: ID $Phone: String $Mobile:String $ContactName: String $Email: String $TradingName: String)  {
              updateSite(id: $cid site:{address:$Address suburb:$Suburb state:$State country:$Country postcode:$Postcode client_id:$Client phone:$Phone mobile:$Mobile contact_name:$ContactName email:$Email trading_name:$TradingName}) {
                id
              }
            }
            `,
            variables: { cid: id, Address: address, Suburb: suburb, State: state,Postcode: postcode,Country: country,Phone: phone,Client: clientId,Mobile: mobile,ContactName: contactName,Email: email,TradingName: tradingName},
        })
        commit('SET_SITES', response.data.updateSite)
    } catch (ex) {
        console.error(ex)
        throw ex
    }
},
    async deleteSite({ commit }, {id} = {}) {
        try {
            // let that = this
            const response = await graphqlClient.mutate({
                mutation: gql`
                mutation DeleteSite($did:Int!)  {
                  deleteSite(id: $did) {
                    id
                  }
                }
                `,
                variables: { did: id},
            })
            commit('SET_SITES', response.data.deleteSite)
        } catch (ex) {
            console.error(ex)
            throw ex
        }
    },

}
